type CitizenshipSectionProps = {
  value: boolean | null
  errorMessage?: string | null
  disabled?: boolean
  onChange: (value: boolean) => void
}

export function CitizenshipSection({
  value,
  errorMessage,
  disabled = false,
  onChange
}: CitizenshipSectionProps) {
  return (
    <>
      <div className="relative z-0 animate-fade-in-up rounded-[8px] " style={{ animationDelay: '120ms' }}>
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-sm font-semibold leading-snug text-gray-dark">
              Are you a U.S. Citizen or Permanent Resident?
              <span className="ml-1 text-red-500">*</span>
            </h2>
            <p className="mt-1 text-left text-xs leading-relaxed text-primary">
              You must be a U.S. citizen or permanent resident to qualify for CDL training.
            </p>
          </div>
          <div className="flex shrink-0 items-center gap-6 pt-1">
            <label className="flex cursor-pointer items-center gap-2 text-sm font-medium text-gray-dark">
              <input
                type="radio"
                name="citizen"
                checked={value === true}
                disabled={disabled}
                onChange={() => onChange(true)}
                className="shrink-0"
              />
              Yes
            </label>
            <label className="flex cursor-pointer items-center gap-2 text-sm font-medium text-gray-dark">
              <input
                type="radio"
                name="citizen"
                checked={value === false}
                disabled={disabled}
                onChange={() => onChange(false)}
                className="shrink-0"
              />
              No
            </label>
          </div>
        </div>
      </div>

      <div className="animate-fade-in-up" style={{ animationDelay: '180ms' }}>
        {errorMessage ? <p className="text-sm text-red-600">{errorMessage}</p> : null}
      </div>
    </>
  )
}
